import {
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    HostListener,
    OnInit,
    ViewChild,
    ViewContainerRef
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { environment } from '../environments/environment';

import {
    AuthSelectors,
    CasesSelectors,
    ClientSelectors,
    SessionDispatchers,
    SessionSelectors
} from './store';
import { MenuService } from './notifications/modals/menu.service';
import { collapseRightTrigger, collapseSidebarTrigger } from './app.animations';
import { Client, SagView } from '@store/models';
import { PrintService } from './print/print.service';
import { LegacyService } from './legacy/legacy.service';
import { filter } from 'rxjs/operators';
import { NavigationService } from './core/navigation.service';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    animations: [collapseSidebarTrigger, collapseRightTrigger],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AppComponent implements OnInit, AfterViewInit {

    env = environment;
    loggedIn$ = this.authSelector.loggedIn$;
    currentClient$ = this.clientSelector.client$;
    currentUser$ = this.authSelector.user$;
    isSupporter$ = this.authSelector.isSupporter$;
    isFaglig$ = this.authSelector.isFaglig$;
    officeName$ = this.authSelector.officeName$;
    officeSettings$ = this.authSelector.officeSettings$;
    sidebarCollapsed$ = this.sessionSelector.sidebarCollapsed$;
    menu$ = this.sessionSelector.menu$;
    clientCases$ = this.casesSelector.clientCases$;
    recentClients$ = this.sessionSelector.recentClients$;
    navigationUrl = '';
    logo = environment['authMode'] === 'cloud' ? 'assets/logo-ia3-white.svg' : 'assets/logo.png';
    noTxtLogo = environment['authMode'] === 'cloud' ? 'assets/logo-ia3-white.svg' : 'assets/logo-notxt.png';

    @ViewChild('statistikModalHost', { read: ViewContainerRef, static: true })
    statistikModalHost!: ViewContainerRef;

    get isIE() {
        return /*@cc_on!@*/false || !!(document as any).documentMode;
    }

    constructor (
        private authSelector: AuthSelectors,
        private sessionSelector: SessionSelectors,
        private sessionDispatcher: SessionDispatchers,
        private clientSelector: ClientSelectors,
        private casesSelector: CasesSelectors,
        public modalsService: MenuService,
        private router: Router,
        private legacyService: LegacyService,
        public printService: PrintService,
        private navigationService: NavigationService,
        private menuService: MenuService,
    ) {}

    ngOnInit() {
        document.querySelector('body').classList.add('nobackground');
        if (window.innerWidth < 800) {
            this.sessionDispatcher.setSidebareCollapsed(true);
        }
        this.router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe((navigationEnd: NavigationEnd) => {
                this.navigationUrl = navigationEnd.url;
            });
    }

    ngAfterViewInit() {
        this.menuService.setStatistikViewContainer(this.statistikModalHost);
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        if (event.target.innerWidth < 768) {
            this.sessionDispatcher.setSidebareCollapsed(true);
        }
    }

    toggleSidebar(value: boolean) {
        this.sessionDispatcher.setSidebareCollapsed(value);
    }

    openStamarkiv(client: Client) {
        const glkundenr = client.glkundenr || '';
        const kid = client.kid || '';
        if (glkundenr === '') { return; } // TODO: implement alert
        const url = `${environment.ia3LegacyUrl}/include/stamarkiv_frame.asp?KNR=${glkundenr}&KID=${kid}`;
        const windowParams = 'scrollbars, resizable, width=1200, height=500, top=100, left=0';
        this.legacyService.ia3Navigate(url, 'StamArkiv', windowParams);
    }

    async openClientCase(value: {clientCase: SagView, kid: string}) {
        const clientCase = value.clientCase;
        await this.navigationService.openCase(value.kid, clientCase.pid?.toString(), clientCase.v2RegnskabsaarKundeId, clientCase.yid);
    }
}
